import React from 'react'
import Stars from '../../../Components/Stars/Stars'
import Text from '../../../Components/Stars/Text'
import '../performance.css'

const PerformanceHeader = () => {
  return (
    <div className='performance-container-title'>
        <span>INFORMATION</span>
        <div className='info-title-container'>
          <Stars times={3}/>
          <Text text='75% - 100%'/>
          <Text text='Exceed Expectation'/>
        </div>

        <div className='info-title-container'>
          <Stars times={2}/>
          <Text text='50% - 74%'/>
          <Text text='Meet Expectation'/>
        </div>

        <div className='info-title-container'>
          <Stars times={1}/>
          <Text text='0% - 49%'/>
          <Text text='Below Expectation'/>
        </div>
      </div>
  )
}

export default PerformanceHeader